import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e384df24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "init" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit" }, "注册账号", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "square" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li"),
    /*#__PURE__*/_createElementVNode("li"),
    /*#__PURE__*/_createElementVNode("li"),
    /*#__PURE__*/_createElementVNode("li"),
    /*#__PURE__*/_createElementVNode("li")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li"),
    /*#__PURE__*/_createElementVNode("li"),
    /*#__PURE__*/_createElementVNode("li"),
    /*#__PURE__*/_createElementVNode("li"),
    /*#__PURE__*/_createElementVNode("li")
  ])
], -1))

import { ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { MyAxios } from "@/plugins/axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserRegisterView',
  setup(__props) {

const router = useRouter();
const store = useStore();

const form = ref({
  userAccount: "",
  userPassword: "",
  checkPassword: "",
});
const handleSubmit = async () => {
  await MyAxios.post("/user/register", form.value).then((res) => {
    if (res.data.code === 0) {
      message.success("注册成功，自动登录！");
      MyAxios.post("/user/login", form.value).then((res) => {
        if (res.data.code === 0) {
          store.dispatch("user/getLoginUser");
          message.success("登录成功!");
          router.push({
            path: "/",
            replace: true,
          });
        } else {
          message.error("登陆失败" + res.data.message);
        }
      });
    } else {
      message.error("注册失败: " + res.data.message);
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.userAccount) = $event)),
        type: "text",
        placeholder: "账号"
      }, null, 512), [
        [_vModelText, form.value.userAccount]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.userPassword) = $event)),
        type: "password",
        placeholder: "密码"
      }, null, 512), [
        [_vModelText, form.value.userPassword]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.checkPassword) = $event)),
        type: "password",
        placeholder: "确认密码"
      }, null, 512), [
        [_vModelText, form.value.checkPassword]
      ]),
      _createElementVNode("button", { onClick: handleSubmit }, "注册")
    ]),
    _hoisted_4,
    _hoisted_5
  ]))
}
}

})